export default {
    dataIterator: {
        rowsPerPageText: 'Elemente für Seiten:',
        rowsPerPageAll: 'Alles',
        pageText: '{0}-{1} di {2}',
        noResultsText: 'Keine Ergebnisse gefunden',
        nextPage: 'Nächste Seite',
        prevPage: 'Vorherige Seite'
    },
    dataTable: {
        rowsPerPageText: 'Zeilen pro Seite:'
    },
    noDataText: 'Keine Artikel verfügbar',
    generic: {
        executeLogin: "Login",
        newAccount: "Neuer Benutzer? Registrieren",
        station_statues:{
            ready: "on-line",
            offline: "off-line",
            out_of_service: "außer Betrieb",
            maintenance: "wartung"
        },
        bay_statues: {
            READY: "Bereit",
            OUT_OF_SERVICE: "Außer Betrieb",
            FAULTY: "Außer Betrieb"
        },
        bay_uses: {
            SHARING: "bike-sharing",
            PRIVATE: "private Aufladung",
            CAR: "auto Aufladung"
        },
        bay_usage_states: {
            PRELIEVO: "abholen",
            RICARICA: "aufladen",
            RICONSEGNA: "abgeben",
            NONE: "Besetzt"
        }
    },
    Login: {
        newAccount: "Neuer Benutzer? Registrieren",
        lostPassword: "Passwort vergessen",
        enter: "Anmelden",
        loginSuccesfully: "Anmeldung erfolgreich!",
        loginSuccesfullyTitle: "ZUGRIFF FERTIG",
        errors: {
            unauthorized: "Username oder Passwort falsch!",
            not_enabled: "Benutzer nicht aktiviert. Überprüfen Sie Ihre E-Mail-Adresse, um Ihre Registrierung zu bestätigen."
        }
    },
    ResetPassword: {
        usernamePlaceholder: "Username",
        emailPlaceholder: "E-Mail-Adresse",
        resetPassword: "Passwort wiederherstellen",
        successTitleReset: "RESET-PASSWORT ANFORDERN DURCHGEFÜHRT",
        successReset: "Anfrage zum Zurücksetzen des Passworts an Ihre E-Mail gesendet. Beobachten Sie Ihre E-Mail und schließen Sie die Vorgänge ab",
        errors: {
            base: {
                no_user: "Konto nicht gefunden!",
                unexpected_error: "Unerwarteter Fehler, wenden Sie sich an die Verwaltung"
            }
        }
    },
    NewAccount: {
        mobilePhonePlaceholder: "Mobiltelefon *",
        smscodePlaceholder: "SMS-code *",
        namePlaceholder: "Vorname",
        surnamePlaceholder: "Nachname *",
        birthDatePlaceholder: "Geburtsdatum *",
        phonePlaceholder: "Handynummer",
        emailPlaceholder: "E-Mail-Adresse *",
        badgePlaceholder: "Chipkarte",
        usernamePlaceholder: "Username *",
        passwordPlaceholder: "Passwort *",
        passwordConfirmationPlaceholder: "Passwort bestätigen *",
        languagePlaceholder: "Sprache",
        residenceAddressPlaceholder: "Wohnanschrift *",
        residenceNumberPlaceholder: "Hausnummer *",
        residenceCapPlaceholder: "Postleitzahl *",
        residenceCityPlaceholder: "Stadtresidenz *",
        residenceDistrictPlaceholder: "Provinz des Wohnsitzes *",
        residenceCountryPlaceholder: "Land des Wohnsitzes *",
        nationalIdentificationNumberPlaceholder: "Steuernummer",
        newUser: "NEUE BENUTZER REGISTRIERUNG",
        infoAccess: "Zugangsinformationen",
        privacyConsent: "Ich habe die DATENSCHUTZERKLÄRUNG gemäß EU-Verordnung 2016/679 gelesen",
        regulationAcceptance: "Ich erkläre, die Bestimmungen gelesen zu haben und zu akzeptieren",
        Register: "Registrieren",
        subscribeSuccesfullyTitle: "Konto erfolgreich erstellt!",
        subscribeSuccesfully: "Perfect! Sie können den Dienst verwenden",
        titlePopupError: "Kontoerstellungsfehler",
        messagePopupError: "Irgendwas ist schief gelaufen. Bitte versuchen Sie es erneut!",
        successSubscription: "Konto erfolgreich erstellt.",
        closePopupPrivacy: "Schließen",
        closePopupRegulation: "Schließen",
        cell_verification_process: "Überprüfen Sie die Handynummer",
        check_phone_number: "Überprüfen Sie das Telefon",
        sms_code_request: "Fordern Sie den Code an",
        invalidPhoneNumber: "Ungültige Telefonnummer",
        invalidSmsCode: "ungültiger code",
        errors: {
            lastname: {
                blank: "Pflichtfeld"
            },
            birth_date: {
                blank: "Pflichtfeld",
                should_be_adult: "nicht konform"
            },
            email: {
                blank: "Pflichtfeld",
                invalid: "Ungültiges Mail-Format"
            },
            username: {
                blank: "Pflichtfeld",
                taken: "Es existiert bereits"
            },
            password: {
                blank: "Pflichtfeld",
                invalid: "Das Passwort muss mindestens 10 Zeichen lang sein und Buchstaben und Zahlen enthalten",
                must_same_password_confirm: "Passwort und Passwortbestätigung müssen übereinstimmen"
            },
            password_confirmation: {
                blank: "Pflichtfeld",
                confirmation: "Passwort und Passwortbestätigung müssen übereinstimmen"
            },
            gdpr_role: {
                inclusion: "Pflichtfeld"
            },
            regulation_acceptance: {
                inclusion: "Pflichtfeld"
            },
            residence_address: {
                blank: "Pflichtfeld"
            },
            residence_number: {
                blank: "Pflichtfeld"
            },
            residence_cap: {
                blank: "Pflichtfeld"
            },
            residence_city: {
                blank: "Pflichtfeld"
            },
            residence_district: {
                blank: "Pflichtfeld"
            },
            residence_country: {
                blank: "Pflichtfeld"
            },
            national_identification_number: {
                taken: "Steuernummer existiert bereits",
                blank: "Pflichtfeld",
                invalid_format: "Falsches format"
            }


        }

    },
    Application: {
        account: "Konto",
        statistics: "Statistiken",
        logout: "Abmelden",
        version: "Vers.",
        rules: "Verordnungen",
        closePopupRules: "Schließen"
    },
    PopUpStation: {
        goToStation: "Zugang zur Station",
        close: "Schließen",
        tableData: {
            name: "Station"
        },
        noResult: "Station nicht gefunden"
    },
    StationInfo: {
        name: "Station",
        availableVehicles: "Verfügbare Fahrzeuge",
        totalCount: "Insgesamt Docks",
        freeBay: "Freie Docks",
        address: "Adresse"
    },
    Station: {
        loginToStation: "Zugang zur Station",
        position: "Dock",
        bayUsageBusyState: "Besetzt",
        availableFor: "Verfügbar für ",
        usages: {
            private: "Privates e-bike Aufladung",
            vehicle_private: "Privates Elektrofahrzeug Aufladung",
            sharing: "Öffentliches E-Bike Aufladung",
            car: "Elektroauto Aufladung",
            charger: "Ladeplatz"
        }
    },
    BasePopUp: {
        close: "Schließen"
    },
    StationLogin: {
        warningMessage: "ACHTUNG!",
        message: "Geben Sie den auf dem Stationsdisplay angezeigten Zugangscode ein.",
        signIn: "Anmelden",
        codePlaceholder: "Zugangscode",
        goodJobMessage: "Gut gemacht!",
        messageSuccessLogin: "Sie haben sich erfolgreich bei der Station authentifiziert",
        messageSuccessLoginNoMonitorCode:"Ihr Anmeldevorgang ist erfolgreich abgeschlossen. Drücken Sie nun die Tasten der Stationssäule.",
        labelStation: "",
        instructions: "Folgen Sie weiter den Anweisungen auf dem Station Display...",
        errorMessage: "Der eingegebene Code ist falsch und stimmt nicht mit dem auf der Senderanzeige überein. Bitte klicken Sie auf den folgenden Button ...",
        retry: "Erneut versuchen"
    },
    Account: {
        mobilePhonePlaceholder: "Telefon handy",
        editUser: "BENUTZERÄNDERUNG",
        editAccount: "Zugangsinformationen",
        namePlaceholder: "Vorname",
        birthDatePlaceholder: "Geburtsdatum *",
        surnamePlaceholder: "Nachname *",
        phonePlaceholder: "Handynummer",
        residenceAddressPlaceholder: "Wohnanschrift *",
        residenceNumberPlaceholder: "Hausnummer *",
        residenceCapPlaceholder: "Postleitzahl *",
        residenceCityPlaceholder: "Stadtresidenz *",
        residenceDistrictPlaceholder: "Provinz des Wohnsitzes *",
        residenceCountryPlaceholder: "Land des Wohnsitzes *",
        nationalIdentificationNumberPlaceholder: "Steuernummer",
        badgePlaceholder: "Chipkarte",
        emailPlaceholder: "E-Mail-Adresse *",
        languagePlaceholder: "Sprache",
        update: "Update",
        updateSuccesfullyTitle: "Gut gemacht!",
        updateSuccesfully: "Kontoinformationen erfolgreich aktualisiert.",
        confirmNewPasswordPlaceholder: "Passwort bestätigen *",
        newPasswordPlaceholder: "Neues Passwort *",
        currentPasswordPlaceholder: "Aktuelles Passwort *",
        updateSuccesfullyAccountTitle: "Gut gemacht!",
        updateAccountSuccesfully: "Aktualisierte Anmeldeinformationen",
        errors:{
            lastname:{
                blank: "Pflichtfeld"
            },
            birth_date: {
                blank: "Pflichtfeld",
                should_be_adult: "nicht konform"
            },
            email: {
                blank: "Pflichtfeld"
            },
            password: {
                must_same_password_confirm: "Passwort und Passwortbestätigung müssen übereinstimmen",
                blank: "Pflichtfeld",
                invalid: "Das Passwort muss mindestens 10 Zeichen lang sein und Buchstaben und Zahlen enthalten"
            },
            old_password: {
                unauthorized: "Aktuelles Passwort falsch",
                blank: "Pflichtfeld"
            },
            password_confirmation: {
                blank: "Pflichtfeld",
                confirmation: "Passwort und Passwortbestätigung müssen übereinstimmen"
            },
            residence_address: {
                blank: "Pflichtfeld"
            },
            residence_number: {
                blank: "Pflichtfeld"
            },
            residence_cap: {
                blank: "Pflichtfeld"
            },
            residence_city: {
                blank: "Pflichtfeld"
            },
            residence_district: {
                blank: "Pflichtfeld"
            },
            residence_country: {
                blank: "Pflichtfeld"
            },
            national_identification_number: {
                taken: "Steuernummer existiert bereits",
                blank: "Pflichtfeld",
                invalid_format: "Falsches format"
            }
        }

    },
    Statistics: {
        servicePlaceholder: "Service",
        dateFromPlaceholder: "Von",
        dateToPlaceholder: "Bis",
        tableHeaders: {
            vehicle: "Fahrzeug"
        },
        services: {
            sharing_unit: "Bike-sharing",
            car_unit: "Elektroauto Aufladungen",
            recharge_unit: "Elektrofahrzeug Aufladungen"
        },
        noResult: "Keine Ergebnisse gefunden",
        showMore: "Weitere Ergebnisse anzeigen"
    },
    NewPassword: {
        passwordPlaceholder: "Neues Passwort",
        passwordConfirmationPlaceholder: "Passwort bestätigen",
        noTokenError: "Token für Passwort-reset nicht gefunden",
        successPasswordChanged: "Jetzt können Sie sich mit Ihrem neuen Passwort anmelden",
        successPasswordChangedTitle: "PASSWORT GEÄNDERT",
        changePassword: "Ändere Passwort",
        errors: {
            password: {
                blank: "Pflichtfeld",
                invalid: "Das Passwort muss mindestens 10 Zeichen lang sein und Buchstaben und Zahlen enthalten",
                must_same_password_confirm: "Passwort und Passwortbestätigung müssen übereinstimmen"
            }
        }
    },
    AppUpgrade: {
        newUpdates: "Update",
        wouldYouUpgrade: "Eine neue Version ist verfügbar. Möchten Sie die Anwendung aktualisieren?",
        update: "Update",
        discardUpdate: "Abbrechen"

    },
    AddToHome: {
        add: "Ok",
        discardAdd: "Abbrechen",
        installApp: "Anwendung installieren",
        installAppMessage: "Für eine bessere Erfahrung empfehlen wir, die Anwendung zum Startbildschirm hinzuzufügen",
        howToInstall: "Für eine bessere Erfahrung empfehlen wir, die Anwendung zum Startbildschirm hinzuzufügen",
        ok: "OK"

    },
    App: {
        offlineMessage: "Zur Nutzung der Anwendung ist eine Internetverbindung erforderlich",
        offlineMessageTitle: "OPS! DU BIST OFFLINE"
    },
    Credit: {
        availableCredit: "GUTHABEN",
        rechargeCredit: "GUTHABEN AUFLADEN",
        paymentsArchive: "Zahlungsarchiv",
        currency: "€",
        noPaymentMethodsMessage: "Es ist nicht möglich, Ihr Guthaben aufzuladen, da keine Zahlungsmethoden verfügbar sind",
        noPaymentMethods: "KEINE ZAHLUNGSMETHODE"
    },
    Braintree: {
        recharge: "Aufladen",
        successPayment: "Gut gemacht!",
        successPaymentMessage: "Erfolgreiche Zahlung",
        errorPayment: "ERROR!",
        errorPaymentMessage: "Fehler beim Verarbeiten der Zahlungsaufforderung"
    },
    Stripe: {
        recharge: "Aufladen",
        successPayment: "Gut gemacht!",
        successPaymentMessage: "Erfolgreiche Zahlung",
        errorPayment: "ERROR!",
        errorPaymentMessage: "Fehler beim Verarbeiten der Zahlungsaufforderung",
        waitingPayment: "WARTEN AUF",
        waitingPaymentMessage: "Zahlung verarbeiten...",
        unexpectedError: "Unerwarteter Fehler",
        processingPayment: "Zahlung läuft"
    },
    Stations: {
        labelStation: "Station",
        address: "Adresse",
        totalSeats: "Insgesamt Docks",
        availableSeats: "Freie Docks",
        availableVehicles: "Verfügbare Fahrzeuge"

    },
    UpdateRequestedUserInfo: {
        warningMessage: "Bitte vervollständigen Sie Ihr Benutzerprofil mit den fehlenden Informationen"
    },
    languages: {
        "IT": "Italiano",
        "EN": "English",
        "ES": "Español",
        "DE": "Deutsch"
    },

    "CurrentSharing": {
        "duration": "Nutzungszeit",
        "startBay": "Startstation",
        "takeAt": "Startdatum/-zeit",
        "title": "Nutzungsinformationen",
        "bike_lock": {
            "button": "SCHLOSS ENTRIEGELN",
            "success_message": "Schloss entriegelt bestätigt",
            "failure_message": "Entriegeln fehlgeschlagen, bitte erneut versuchen."
        }
    }

};